import { ListItemButton } from "@mui/material";
import { Children } from "react";

export const UsuariListButton = ({ onClick, selected, children }) => {
  return (
    <ListItemButton 
      onClick={onClick} 
      selected={selected} sx={{ 
      border: '1px solid #e0e0e0', 
      borderRadius: 4, 
      mb: 1,
      height: 60,
      width: '80%',
      marginBottom: 3,
      '&.Mui-selected': {
        backgroundColor: '#e8f5e9',
        '&:hover': {
          backgroundColor: '#c8e6c9',
        },
      },
    }}>
      {Children.map(children, child => {
        return child;
      })}
    </ListItemButton>
  )
}
